export const overtimeConstants = {
    // Data loading
    GET_OVERTIME_DATA: "GET_OVERTIME_DATA",
    GET_OVERTIME_DATA_SUCCESS: "GET_OVERTIME_DATA_SUCCESS",
    GET_OVERTIME_DATA_FAILED: "GET_OVERTIME_DATA_FAILED",

    // Employee item collapse
    TOGGLE_ITEM_COLLAPSED: "TOGGLE_ITEM_COLLAPSED",

    // Contact status (answered, notes, phoneNumber)
    SET_CONTACT: "SET_CONTACT",

    // Shift signup decision selection
    SELECT_DECISION: "SELECT_DECISION",

    // Confirm decision
    CONFIRM_DECISION: "CONFIRM_DECISION",
    CONFIRM_DECISION_SUCCESS: "CONFIRM_DECISION_SUCCESS",
    CONFIRM_DECISION_FAILED: "CONFIRM_DECISION_FAILED",

    // Add OT Shift (Assign)
    ADD_OT_SHIFT: "ADD_OT_SHIFT",
    ADD_OT_SHIFT_SUCCESS: "ADD_OT_SHIFT_SUCCESS",
    ADD_OT_SHIFT_FAILED: "ADD_OT_SHIFT_FAILED",

    // Clear signup error
    CLEAR_SIGNUP_ERROR: "CLEAR_SIGNUP_ERROR",

    // Overtime slots (passed from different component)
    SET_OVERTIME_SLOTS: "SET_OVERTIME_SLOTS",

    // Loader
    SHOW_OVERTIME_LOADER: "SHOW_OVERTIME_LOADER",

    // Cleanup
    OVERTIME_CLEANUP: "OVERTIME_CLEANUP",

    // Resolve WB Failed
    RESOLVE_OT_WB_FAILED: "RESOLVE_OT_WB_FAILED",
    RESOLVE_OT_WB_FAILED_SUCCESS: "RESOLVE_OT_WB_FAILED_SUCCESS",
    RESOLVE_OT_WB_FAILED_FAILED: "RESOLVE_OT_WB_FAILED_FAILED",

    GET_OT_SKILLS: "GET_OT_SKILLS",
    GET_OT_SKILLS_DATA: "GET_OT_SKILLS_DATA",
    GET_OT_SKILLS_SUCCESS: "GET_OT_SKILLS_SUCCESS"
};
